var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v(" Case Counts ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 col-lg-2"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "h5 text-warning text-center mb-0 mt-2"
  }, [_c('router-link', {
    class: [{
      'click-not-allowed': _vm.emailStatus.AllocationPending <= 0
    }, 'text-warning'],
    attrs: {
      "target": "_self",
      "title": "Pending Cases",
      "to": {
        path: '/emailtracking',
        query: {
          status: 'allocationpending',
          tlemail: _vm.filter.tlemailid
        }
      }
    }
  }, [_vm._v("\n                             " + _vm._s(_vm.emailStatus.AllocationPending) + "\n                       ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "h6 text-warning text-center mb-0 mt-2"
  }, [_vm._v("Pending")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted font-weight-bold text-center font-xs"
  }, [_c('small', [_vm._v("(As Of Now)")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-2"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "h5 text-danger text-center mb-0 mt-2"
  }, [_c('router-link', {
    class: [{
      'click-not-allowed': _vm.emailStatus.Allocated <= 0
    }, 'text-danger'],
    attrs: {
      "target": "_self",
      "title": "Allocated Cases",
      "to": {
        path: '/emailtracking',
        query: {
          status: 'allocated',
          tlemail: _vm.filter.tlemailid
        }
      }
    }
  }, [_vm._v("\n                             " + _vm._s(_vm.emailStatus.Allocated) + "\n                      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "h6 text-danger text-center mb-0 mt-2"
  }, [_vm._v("Allocated")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted font-weight-bold text-center font-xs"
  }, [_c('small', [_vm._v("(As Of Now)")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-2"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "h5 text-primary text-center mb-0 mt-2"
  }, [_c('router-link', {
    class: [{
      'click-not-allowed': _vm.emailStatus.InProcess <= 0
    }, 'text-primary'],
    attrs: {
      "target": "_self",
      "title": "InProcess Cases",
      "to": {
        path: '/emailtracking',
        query: {
          status: 'inprocess',
          tlemail: _vm.filter.tlemailid
        }
      }
    }
  }, [_vm._v("\n                       " + _vm._s(_vm.emailStatus.InProcess) + "\n                     ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "h6 text-primary text-center mb-0 mt-2"
  }, [_vm._v("In Process")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted font-weight-bold text-center font-xs"
  }, [_c('small', [_vm._v("(As Of Now)")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-2"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "h5 text-success text-center mb-0 mt-2"
  }, [_c('router-link', {
    staticClass: "has-text-black-bis",
    class: [{
      'click-not-allowed': _vm.emailStatus.Close <= 0
    }, 'text-success'],
    attrs: {
      "target": "_self",
      "title": "Close Cases",
      "to": {
        path: '/emailtracking',
        query: {
          status: 'close',
          tlemail: _vm.filter.tlemailid
        }
      }
    }
  }, [_vm._v("\n                       " + _vm._s(_vm.emailStatus.Close) + "\n                     ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "h6 text-success text-center mb-0 mt-2"
  }, [_vm._v("Close")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-center font-weight-bold font-xs"
  }, [_c('small', [_vm._v("(Today)")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-2"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "h5 text-secondary text-center mb-0 mt-2"
  }, [_c('router-link', {
    staticClass: "has-text-black-bis",
    class: [{
      'click-not-allowed': _vm.emailStatus.Spam <= 0
    }, 'text-secondary'],
    attrs: {
      "target": "_self",
      "title": "Spam Cases",
      "to": {
        path: '/emailtracking',
        query: {
          status: 'spam',
          tlemail: _vm.filter.tlemailid
        }
      }
    }
  }, [_vm._v("\n                           " + _vm._s(_vm.emailStatus.Spam) + "\n                       ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "h6 text-secondary text-center mb-0 mt-2"
  }, [_vm._v("Spam")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-center font-weight-bold font-xs"
  }, [_c('small', [_vm._v("(Today)")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-2"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "h5 text-primary text-center mb-0 mt-2"
  }, [_c('router-link', {
    staticClass: "has-text-black-bis",
    class: [{
      'click-not-allowed': _vm.emailStatus.FollowUp <= 0
    }, 'text-primary'],
    attrs: {
      "target": "_self",
      "title": "Follow Up Cases",
      "to": {
        path: '/emailtracking',
        query: {
          status: 'followup',
          tlemail: _vm.filter.tlemailid
        }
      }
    }
  }, [_vm._v("\n                           " + _vm._s(_vm.emailStatus.FollowUp) + "\n                       ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "h6 text-primary text-center mb-0 mt-2"
  }, [_vm._v("Follow Up")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-center font-weight-bold font-xs"
  }, [_c('small', [_vm._v("(Today)")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-2"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "h5 text-danger text-center mb-0 mt-2"
  }, [_c('router-link', {
    class: [{
      'click-not-allowed': !_vm.emailRepeatStatusCount
    }, 'text-danger'],
    attrs: {
      "target": "_self",
      "to": {
        path: '/emailtracking',
        query: {
          repeatstatus: 'repeatstatus',
          status: 'allocationpending',
          tlemail: _vm.filter.tlemailid
        }
      }
    }
  }, [_vm._v("\n                     " + _vm._s(_vm.emailRepeatStatusCount) + "\n                     ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "h6 text-danger text-center mb-0 mt-2"
  }, [_vm._v("Repeat Emails")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-center font-weight-bold font-xs"
  }, [_vm._v(".")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v(" Previous Day Status ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 col-lg-2"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "h5 text-primary text-center mb-0 mt-2"
  }, [_vm._v("\n                         " + _vm._s(_vm.previousDay.TotalEmailsReceived) + "\n                   ")]), _vm._v(" "), _c('div', {
    staticClass: "h6 text-primary text-center mb-0 mt-2"
  }, [_vm._v("Total Email Received")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted font-weight-bold text-center font-xs"
  }, [_c('small', [_vm._v("24 Hrs Format")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-2"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "h5 text-primary text-center mb-0 mt-2"
  }, [_vm._v("\n                         " + _vm._s(_vm.previousDay.EmailsReceived) + "\n                   ")]), _vm._v(" "), _c('div', {
    staticClass: "h6 text-primary text-center mb-0 mt-2"
  }, [_vm._v("Email Received")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted font-weight-bold text-center font-xs"
  }, [_c('small', [_vm._v("NonWorking Hour 8 PM-8.59 AM")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-2"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "h5 text-primary text-center mb-0 mt-2"
  }, [_vm._v("\n                         " + _vm._s(_vm.previousDay.TotalEmailsClosed) + "\n                   ")]), _vm._v(" "), _c('div', {
    staticClass: "h6 text-primary text-center mb-0 mt-2"
  }, [_vm._v("Total Email Closed")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted font-weight-bold text-center font-xs"
  }, [_c('small', [_vm._v("8.59 AM - 8.30 PM")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-2"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "h5 text-primary text-center mb-0 mt-2"
  }, [_vm._v("\n                         " + _vm._s(_vm.previousDay.TotalEmailsSpam) + "\n                   ")]), _vm._v(" "), _c('div', {
    staticClass: "h6 text-primary text-center mb-0 mt-2"
  }, [_vm._v(" Total Email Spam")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted font-weight-bold text-center font-xs"
  }, [_c('small', [_vm._v("8.59 AM - 8.30 PM")])])])], 1)])])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72e1104c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/emailr/tlDashboard.vue
// module id = 892
// module chunks = 1